module.exports = __webpack_public_path__ + "img/retiro.7cb43d9c.png";